<script>
import { defineAsyncComponent } from 'vue';

import { onMounted, onUnmounted } from 'vue'
import { useHead } from '@unhead/vue'

const Interstitial = defineAsyncComponent({
  loader: () => import('@/components/wrappers/Interstitial.vue'),
})
const Exterior = defineAsyncComponent({
  loader: async () => import('@/components/wrappers/Exterior.vue'),
  loadingComponent: Interstitial,
  delay: 200
})
const Interior = defineAsyncComponent({
  loader: () => import('@/components/wrappers/Interior.vue'),
  loadingComponent: Interstitial,
  delay: 200
})
const events = ['dragenter', 'dragover', 'dragleave', 'drop']

export default {
  head() {
      const templateParams = {
        separator: '|',
        site: {
          name: import.meta.env.VITE_SITE_NAME
        }
      }
      return {
        templateParams,
        title: () => this.$route.meta?.title ?? null,
        titleTemplate: '%site.name %separator %s',
        meta: [
          { 'og:url': import.meta.env.VITE_APP_BASE + this.$route.path ?? null },
          { 'og:title': () => this.$route.meta?.title ?? null },
        ]
      }
  },
  setup() {
    function preventDefaults(e) {
      e.preventDefault()
    }

    onMounted(() => {
      events.forEach((name) => {
        document.addEventListener(name, preventDefaults)
      })
    })

    onUnmounted(() => {
      events.forEach((name) => {
        document.body.removeEventListener(name, preventDefaults)
      })
    })
  },
  computed: {
    requiresAuth() {
      return this.$route.meta?.acl?.auth || false;
    }
  },
  components: {
    Interior,
    Exterior,
    Interstitial
  }
}
</script>

<template>
  <Interior v-if="requiresAuth">
    <router-view />
  </Interior>
  <Exterior v-else>
    <router-view />
  </Exterior>
</template>